import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { Typography } from '../../theme/fonts';

export const H1 = ({ style, children, ...props }) => (
  <Text style={[styles.h1, style]} {...props}>{children}</Text>
);

export const H2 = ({ style, children, ...props }) => (
  <Text style={[styles.h2, style]} {...props}>{children}</Text>
);

export const H3 = ({ style, children, ...props }) => (
  <Text style={[styles.h3, style]} {...props}>{children}</Text>
);

export const Body1 = ({ style, children, ...props }) => (
  <Text style={[styles.body1, style]} {...props}>{children}</Text>
);

export const Body2 = ({ style, children, ...props }) => (
  <Text style={[styles.body2, style]} {...props}>{children}</Text>
);

export const Caption = ({ style, children, ...props }) => (
  <Text style={[styles.caption, style]} {...props}>{children}</Text>
);

export const ButtonText = ({ style, children, ...props }) => (
  <Text style={[styles.button, style]} {...props}>{children}</Text>
);

const styles = StyleSheet.create({
  h1: {
    ...Typography.header1,
  },
  h2: {
    ...Typography.header2,
  },
  h3: {
    ...Typography.header3,
  },
  body1: {
    ...Typography.body1,
  },
  body2: {
    ...Typography.body2,
  },
  caption: {
    ...Typography.caption,
  },
  button: {
    ...Typography.button,
  },
});

export default {
  H1,
  H2,
  H3,
  Body1,
  Body2,
  Caption,
  ButtonText,
};
